import script from "./Generate.vue?vue&type=script&setup=true&lang=ts"
export * from "./Generate.vue?vue&type=script&setup=true&lang=ts"

import "./Generate.scss?vue&type=style&index=0&id=c1d56c3a&scoped=true&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c1d56c3a"]])

export default __exports__